import { routerReducer } from '@ngrx/router-store';
import { Action, ActionReducer, ActionReducerMap, MetaReducer } from '@ngrx/store';

import * as adm from '@admin/store/admin.reducers';
import * as authActions from '@auth/store/auth.actions';
import * as auth from '@auth/store/auth.reducers';
import * as inv from '@inventory/store/inventory.reducers';
import * as ord from '@orders/store/orders.reducers';
import { localStorageSync } from 'ngrx-store-localstorage';

import * as data from '../data/store/data.reducers';
import * as rpt from '../reports/store/report.reducers';
import * as pcache from './pcache/pcache.reducers';
import * as tempData from './tempdata/tempdata.reducers';

export interface AppState {
  auth: auth.AuthState;
  router: any;
  data: data.DataState;
  tempData: tempData.TempDataState;
  pcache: pcache.PCacheState;
  inventory: inv.InventoryState;
  order: ord.OrderState;
  admin: adm.AdminState;
  report: rpt.ReportState;
}

export const reducers: ActionReducerMap<AppState> = {
  auth: auth.authReducer,
  data: data.dataReducer,
  tempData: tempData.tempDataReducer,
  pcache: pcache.pCacheReducer,
  inventory: inv.inventoryReducer,
  order: ord.orderReducer,
  admin: adm.adminReducer,
  report: rpt.reportReducer,
  router: routerReducer,
};

// this determines which main branches of the store are persisted to local storage
// if this becomes a performance issue, we may want to exclude tempData (if tempData becomes too large)
export function localStorageSyncReducer(reducer: ActionReducer<any>): ActionReducer<any> {
  return localStorageSync({
    keys: ['auth', 'data', 'pcache', 'inventory', 'order', 'admin', 'report', 'tempData', 'router'],
    rehydrate: true,
  })(reducer);
}

export function clearState(reducer: ActionReducer<any>): ActionReducer<any> {
  return function (state: AppState, action: Action): AppState {
    let tempState = { ...state };
    if (action.type === authActions.LOGOUT || action.type === authActions.LOGIN_INIT) {
      tempState = {
        ...state,
        auth: action.type === authActions.LOGOUT ? auth.initialState : { ...state.auth },
        data: data.initialState,
        tempData: tempData.initialState,
        inventory: inv.initialState,
        order: ord.initialState,
        admin: adm.initialState,
        report: rpt.initialState,
      };
    }
    return reducer(tempState, action);
  };
}

export const metaReducers: MetaReducer<AppState>[] = [localStorageSyncReducer, clearState];
